import React from 'react';
import { remCss, scssVariables as variables } from 'src/helpers';

const InfectiousDiseasesIcon = React.memo(({ width = 81, height = 80, viewBox = '0 0 81 80' }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={remCss(width)}
    height={remCss(height)}
    viewBox={viewBox}
  >
    <path
      fill={variables['colors-mc-primary']}
      fillOpacity='0.1'
      stroke={variables['colors-mc-primary']}
      d='M79.6426 40C79.6426 61.8153 61.9578 79.5 40.1426 79.5C18.3273 79.5 0.642578 61.8153 0.642578 40C0.642578 18.1848 18.3273 0.5 40.1426 0.5C61.9578 0.5 79.6426 18.1848 79.6426 40Z'
    />
    <g clipPath='url(#clip0_414_10575)'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M25.132 22.7754L38.3332 35.9765V17.3071H41.6666V35.9766L54.8679 22.7754L57.2246 25.1321L44.0234 38.3334H62.6928V41.6667H44.0234L57.2246 54.8679L54.8679 57.2246L41.6666 44.0235V62.6929H38.3332V44.0235L25.132 57.2246L22.7753 54.8679L35.9764 41.6667H17.3071V38.3334H35.9765L22.7753 25.1321L25.132 22.7754Z'
        fill='#D94452'
      />
      <path
        d='M49.816 49.8216C55.2403 44.3973 55.2403 35.6027 49.816 30.1784C44.3916 24.754 35.597 24.754 30.1727 30.1784C24.7484 35.6027 24.7484 44.3973 30.1727 49.8216C35.597 55.246 44.3916 55.246 49.816 49.8216Z'
        fill='#F76C82'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M44.086 36.972C45.6826 36.972 46.9849 35.6697 46.9849 34.073C46.9849 32.4764 45.6826 31.1741 44.086 31.1741C42.4893 31.1741 41.187 32.4764 41.187 34.073C41.187 35.6697 42.4893 36.972 44.086 36.972Z'
        fill='#D94452'
      />
      <path
        d='M34.3513 41.1254C35.2835 40.1932 35.2835 38.6818 34.3513 37.7496C33.4191 36.8174 31.9077 36.8174 30.9755 37.7496C30.0433 38.6818 30.0433 40.1932 30.9755 41.1254C31.9077 42.0576 33.4191 42.0576 34.3513 41.1254Z'
        fill='#D94452'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M44.4419 48.4045C46.3204 48.4045 47.8525 46.8724 47.8525 44.9939C47.8525 43.1153 46.3204 41.5833 44.4419 41.5833C42.5633 41.5833 41.0313 43.1153 41.0313 44.9939C41.0311 46.8723 42.5633 48.4045 44.4419 48.4045Z'
        fill='#D94452'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M22.3223 22.3223C24.2372 20.4074 26.4847 19.5501 27.3422 20.4076C28.1997 21.2651 27.3424 23.5125 25.4275 25.4275C23.5126 27.3425 21.2651 28.1997 20.4076 27.3423C19.5501 26.4848 20.4073 24.2373 22.3223 22.3223ZM40 15C42.7081 15 44.9035 15.983 44.9035 17.1957C44.9035 18.4083 42.7081 19.3915 40 19.3915C37.2919 19.3915 35.0965 18.4084 35.0965 17.1957C35.0965 15.983 37.2918 15 40 15ZM57.6777 22.3223C59.5927 24.2372 60.4499 26.4848 59.5924 27.3422C58.7349 28.1997 56.4875 27.3424 54.5725 25.4275C52.6576 23.5126 51.8003 21.2651 52.6577 20.4076C53.5152 19.5501 55.7627 20.4073 57.6777 22.3223ZM65 40C65 42.7081 64.017 44.9035 62.8043 44.9035C61.5917 44.9035 60.6085 42.7081 60.6085 40C60.6085 37.2919 61.5916 35.0965 62.8043 35.0965C64.017 35.0965 65 37.2918 65 40ZM57.6777 57.6777C55.7627 59.5927 53.5152 60.4499 52.6578 59.5924C51.8003 58.7349 52.6576 56.4875 54.5725 54.5725C56.4874 52.6576 58.7349 51.8003 59.5924 52.6577C60.4499 53.5152 59.5927 55.7627 57.6777 57.6777ZM40 65C37.2919 65 35.0965 64.017 35.0965 62.8043C35.0965 61.5916 37.2919 60.6085 40 60.6085C42.7081 60.6085 44.9035 61.5916 44.9035 62.8043C44.9035 64.017 42.7082 65 40 65ZM22.3223 57.6777C20.4074 55.7628 19.5501 53.5153 20.4076 52.6578C21.265 51.8003 23.5125 52.6576 25.4275 54.5725C27.3425 56.4874 28.1997 58.7349 27.3423 59.5924C26.4848 60.4499 24.2373 59.5927 22.3223 57.6777ZM15 40C15 37.2919 15.983 35.0965 17.1957 35.0965C18.4084 35.0965 19.3914 37.2919 19.3914 40C19.3914 42.7081 18.4083 44.9035 17.1956 44.9035C15.9829 44.9035 15 42.7082 15 40Z'
        fill='#EB5463'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M35.3744 32.5724C36.2043 32.5724 36.8812 31.8955 36.8812 31.0656C36.8812 30.2357 36.2043 29.5588 35.3744 29.5588C34.5446 29.5588 33.8677 30.2357 33.8677 31.0656C33.8677 31.8955 34.5446 32.5724 35.3744 32.5724Z'
        fill='#D94452'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M34.4413 48.3685C35.2712 48.3685 35.9481 47.6916 35.9481 46.8618C35.9481 46.0319 35.2712 45.355 34.4413 45.355C33.6114 45.355 32.9346 46.0319 32.9346 46.8618C32.9346 47.6916 33.6115 48.3685 34.4413 48.3685Z'
        fill='#D94452'
      />
    </g>
    <defs>
      <clipPath id='clip0_414_10575'>
        <rect width='50' height='50' fill='white' transform='translate(15.1426 15)' />
      </clipPath>
    </defs>
  </svg>
));
InfectiousDiseasesIcon.displayName = 'InfectiousDiseasesIcon';
export default InfectiousDiseasesIcon;
